import { Download, Trash2, Image as ImageIcon } from "lucide-react";
import type FileAssetDTO from "../../types/dtos/fileAssets/FileAssetDTO";
import {
  KeyValueViewType,
  type KeyValueItem,
} from "@repo/types/ui/keyValuePairs";
import type FileProps from "../../types/ui/files/FileProps";
import KeyValueMenu from "../ui/menu/KeyValueMenu";
import { useDialog } from "../../hooks/contexts";
import { useDownloadFileAsset } from "../../hooks/queries";

export interface FileActionsMenuProps extends FileProps {
  file: FileAssetDTO;
  onPreview: (index: number) => void;
}

export default function FileActionsMenu({
  file,
  index,
  onPreview,
  onDelete,
}: FileActionsMenuProps) {
  const dialog = useDialog();
  const { mutateAsync: downloadAsset } = useDownloadFileAsset();

  const fileActionItems: KeyValueItem[] = [
    {
      Id: 1,
      Value: "View",
      viewType: KeyValueViewType.iconAndText,
      icon: <ImageIcon size={14} />,
      classNames: "p-1 text-sm hover:bg-gray-100",
    },
    {
      Id: 2,
      Value: "Download",
      viewType: KeyValueViewType.iconAndText,
      icon: <Download size={14} />,
      classNames: "p-1 text-sm hover:bg-gray-100",
    },
    {
      Id: 3,
      Value: "Delete",
      viewType: KeyValueViewType.iconAndText,
      icon: <Trash2 size={14} />,
      classNames: "p-1 text-sm hover:bg-gray-100 text-red-500",
    },
  ];

  const handleAction = async (action: number) => {
    if (action === 1) {
      onPreview(index);
    }

    if (action === 2) {
      await downloadAsset(file.Id);
    }

    if (action === 3) {
      if (
        await dialog.confirm({
          title: "Confirm Deletion",
          message: `Are you sure you want to delete "${file.OriginalFileName}"? This action cannot be undone.`,
          confirmText: "Delete",
        })
      ) {
        onDelete?.(file.Id);
      }
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="bg-white">
      <KeyValueMenu
        items={fileActionItems}
        onValueChange={handleAction}
        triggerRenderer={() => {
          return (
            <div className="px-2 py-1 rounded cursor-pointer hover:bg-gray-100 shadow-sm hover:shadow-md transition-shadow">
              •••
            </div>
          );
        }}
        popupClassNames="w-32"
      />
    </div>
  );
}
